import { useMemo } from "react";

import classnames from "classnames";
import { sortBy } from "lodash";
import { useTranslation } from "react-i18next";

import { Text } from "components/ui/source";

import { UpgradeService } from "types/graphql";

import IconText from "../../IconText";
import { getUpgradeConfig } from "../getUpgradesConfig";

import styles from "./UpgradesList.module.scss";

interface Props {
  upgrades: UpgradeService[];
  className?: string;
}

export default function UpgradesList({ className, upgrades }: Props) {
  const { t } = useTranslation();
  const upgradesElements = useMemo(
    () =>
      sortBy(upgrades, "type").map(u => (
        <div
          key={u.type}
          className={styles.upgrade}
          data-testid="list-upgrade-item"
        >
          <IconText
            Icon={getUpgradeConfig(u, t).Icon}
            title={getUpgradeConfig(u, t).titleTranslateKey}
            titleTextProps={{ className: styles.title }}
          />
          <div className={styles.upgradePrice}>
            {getUpgradeConfig(u, t).price}
          </div>
        </div>
      )),
    [upgrades, t],
  );

  if (!upgrades || upgrades.length == 0) return null;

  return (
    <div className={classnames(className, styles.container)}>
      <Text
        className={styles.sectionTitle}
        types={["caption1"]}
        translateKey="listing:building.roomUpgrades"
      />
      <div className={styles.listContainer}>{upgradesElements}</div>
    </div>
  );
}
